import { icons } from 'src/assets/iconDef/icon.def';

export const ambulanceMenuDef = [
    {
        name: 'menu.ambulance',
        icon: 'fa fa-plus-square',
        data: {
            nav_url: 'ambulance-management'
        },
        children: [
            {
                name: 'menu.ambulance_dashboard',
                resource: 'ambulance_dashboard',
                icon: 'fa fa-tag',
                url: 'ambulance_dashboard',
                breadcrumb: "Dashboard",
                auto_crud: true,
            },
            {
                name: 'menu.paramedic_orders',
                resource: 'paramedic',
                icon: 'fa fa-h-square',
                url: 'paramedic',
                breadcrumb: "paramedic",
                auto_crud: false
            },
            {
                name: 'menu.paramedic_orders',
                resource: 'paramedic_orders_completed',
                icon: 'fa fa-h-square',
                url: 'paramedic_orders_completed',
                breadcrumb: "paramedic",
                auto_crud: true
            },
            {
                name: 'menu.paramedic_orders',
                resource: 'paramedic_orders_cancelled',
                icon: 'fa fa-h-square',
                url: 'paramedic_orders_cancelled',
                breadcrumb: "paramedic",
                auto_crud: true
            },
            {
                name: 'menu.paramedic_orders',
                resource: 'paramedic_orders',
                icon: 'fa fa-h-square',
                url: 'paramedic_orders',
                breadcrumb: "paramedic",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.paramedic_order_format',
                resource: 'paramedic_order_format',
                icon: 'fa fa-h-square',
                url: 'paramedic_order_format',
                breadcrumb: "paramedic",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.ambulance_erconnect',
                resource: 'er-connect',
                icon: 'fa fa-h-square',
                url: 'er-connect',
                breadcrumb: "er-connect",
                auto_crud: false
            },
            {
                name: 'menu.ambulance_request',
                resource: 'ambulance_request',
                icon: 'fa fa-tag',
                url: 'ambulance_request',
                breadcrumb: "ambulance_request",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.patient_ambulance_request',
                resource: 'ambulance_request',
                view: 'patient_ambulance_request',
                icon: 'fa fa-tag',
                url: 'patient_ambulance_request',
                breadcrumb: "ambulance_request",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.ambulance_approve',
                resource: 'ambulance_approve',
                icon: 'fa fa-tag',
                url: 'ambulance_approve',
                breadcrumb: "ambulance_approve",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.ambulance_request_rejected',
                resource: 'ambulance_request_rejected',
                icon: 'fa fa-tag',
                url: 'ambulance_request_rejected',
                breadcrumb: "ambulance_request_rejected",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.ambulance_order_completed',
                resource: 'ambulance_order_completed',
                icon: 'fa fa-tag',
                url: 'ambulance_order_completed',
                breadcrumb: "ambulance_order_completed",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'menu.ambulance_order_cancelled',
                resource: 'ambulance_order_cancelled',
                icon: 'fa fa-tag',
                url: 'ambulance_order_cancelled',
                breadcrumb: "ambulance_order_cancelled",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'Cancelled Orders',
                resource: 'ambulance_order_cancelled',
                icon: 'fa fa-tag',
                url: 'ambulance_order_cancelled',
                breadcrumb: "ambulance_order_cancelled",
                auto_crud: true,
                showMenu: false
            },
            {
                name: 'Ambulance Billing',
                resource: 'ambulance_billing_format',
                icon: 'fa fa-tag',
                url: 'ambulance_billing_format',
                breadcrumb: "ambulance_billing_format",
                auto_crud: true,
                showMenu: false
            }

        ]
    }
]